import { lazy } from 'react';

import type { TRoute } from 'shared/presentation/modules/definitions';

const NearbyUnits = lazy(
  () => import('modules/institutional/presentation/pages/NearbyUnits'),
);
const SearchUnits = lazy(
  () => import('modules/institutional/presentation/pages/SearchUnits'),
);
const UnitDetails = lazy(
  () => import('modules/institutional/presentation/pages/UnitDetails'),
);

const institutionalRoutes: TRoute[] = [
  {
    type: 'route',
    path: '/busca-unidades',
    component: SearchUnits,
  },
  {
    type: 'route',
    path: '/unidades-proximas',
    component: NearbyUnits,
  },
  {
    type: 'route',
    path: '/unidade/:id',
    component: UnitDetails,
  },
];

export default institutionalRoutes;
